// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreOrderProductsApiModel from "../api-model/PorterStoreOrderProductsApiModel.bs.js";

function decodeVariant(data) {
  return {
          sku: data.sku,
          size_code: data.size_code,
          is_active: data.is_active
        };
}

function decodeImage(data) {
  return {
          image_url: data.image_url
        };
}

function decodeProduct(data) {
  var p = data.pricing;
  var priceMinor = p !== undefined ? Belt_Option.getWithDefault(p.sale_amount_minor, Belt_Option.getWithDefault(p.list_amount_minor, 0)) : 0;
  return {
          code: data.code,
          name: data.name,
          description: data.description,
          is_active: data.is_active,
          images: Belt_Array.map(Belt_Option.getWithDefault(data.images, []), decodeImage),
          variants: Belt_Array.map(data.variants, decodeVariant),
          has_validation: data.has_validation,
          price_minor: priceMinor
        };
}

function execute(json) {
  var response = DeccoUtils$Catalyst.resolveResult(PorterStoreOrderProductsApiModel.t_decode(json), "PorterStoreOrderProductsEntityMapper.res");
  var requiredProductCodes = Belt_Array.map(Belt_Option.getWithDefault(response.validations, []), (function (v) {
          return v.config.product_code;
        }));
  return Belt_Array.map(response.products, (function (product) {
                var decoded = decodeProduct(product);
                var isRequired = Belt_Array.some(requiredProductCodes, (function (code) {
                        return code === decoded.code;
                      }));
                return {
                        code: decoded.code,
                        name: decoded.name,
                        description: decoded.description,
                        is_active: decoded.is_active,
                        images: decoded.images,
                        variants: decoded.variants,
                        has_validation: isRequired ? true : decoded.has_validation,
                        price_minor: decoded.price_minor
                      };
              }));
}

export {
  decodeVariant ,
  decodeImage ,
  decodeProduct ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
